import { CheckCircleOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import {
  LIVE_DIGITAL_USER_LABELS,
  buildLiveDigitalLinkExample,
  getLiveDigitalBrand,
  getLiveDigitalParamsExample,
  isLiveDigitalMeetingUrl,
} from '@/helpers/new/liveDigitalMeetingLink'
import s from './index.module.css'

// Подсказка под полем ввода ссылки: показывается только для комнаты LiveDigital/TeleBoss.
// Параметры перехода подставляются автоматически, вручную их вводить не нужно.
// forChildren — поле ссылки для учащихся: при переходе ученика передаётся ID ученика.
export const LiveDigitalLinkHint = ({ value, className, forChildren = false }) => {
  if (!isLiveDigitalMeetingUrl(value)) return null

  const userLabel = forChildren
    ? LIVE_DIGITAL_USER_LABELS.student
    : LIVE_DIGITAL_USER_LABELS.teacher
  const example = buildLiveDigitalLinkExample(value, userLabel)
  // TeleBoss — тот же сервис под другим брендом, показываем распознанное имя
  const brand = getLiveDigitalBrand(value)

  return (
    <div className={classNames(s.hint, className)} role="note">
      <CheckCircleOutlined className={s.icon} />
      <div className={s.content}>
        <span className={s.title}>{brand}:</span>{' '}
        {`при переходе на занятие автоматически передадим ${userLabel} и ID занятия`}
        {/* в подсказке показываем только добавляемый хвост, полный пример — в title */}
        {!!example && (
          <div className={s.example} title={example}>
            {getLiveDigitalParamsExample(userLabel)}
          </div>
        )}
      </div>
    </div>
  )
}

export default LiveDigitalLinkHint
